import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'

import './../node_modules/bulma/css/bulma.css';
import './../node_modules/@fortawesome/fontawesome-free/css/fontawesome.css'
import './../node_modules/@fortawesome/fontawesome-free/css/solid.css'

Vue.prototype.$http = Axios;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
